window.mrkTotal = 0;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$(document).ready(function() {
    $('form .mrk-postal-code-input').val(localStorage.getItem('postalCode'));
    $('.mrk-postal-code-input').on('input', function() {
        var inputVal = $(this).val().trim().replace(/[^0-9]/g, '');
        // Check if the input length is less than 5
        if (inputVal.length < 5) {
            $('.mrk-city-postal-wrapper').css('display', 'none');
            $('.mrk-success-wrapper').css('display', 'none');
            if(inputVal == 0){
                $('.mrk-error-wrapper').hide();
                $('.mrk-form-input-inner-wrapper').removeClass('error');
                return
            }
            $('.mrk-error-wrapper').css('display', 'block').find('.mrk-error').text(window.in_valid);
            $('.mrk-form-input-inner-wrapper').addClass('error');
            $('.choose-services').prop('disabled', true);
        } else {
            var postalCodeObj = postalCodes.find(function(item) {
                return item.postalCode === Number(inputVal);
            });

            if (postalCodeObj) {
                // If postal code is found
                $('.mrk-city-name').text(postalCodeObj.city);
                $('.mrk-post-code').text(postalCodeObj.postalCode);
                $('.mrk-city-postal-wrapper').css('display', 'flex');
                $('.mrk-success-wrapper').css('display', 'flex');
                $('.mrk-error-wrapper').css('display', 'none');
                $('.mrk-form-input-inner-wrapper').removeClass('error');
                $('.choose-services').prop('disabled', false);
                localStorage.setItem('postalCode', postalCodeObj.postalCode);
                $('.selected-city-name').html(postalCodeObj.city);
            } else {
                // If postal code is not found and length is 5 or more
                $('.mrk-city-postal-wrapper').css('display', 'none');
                $('.mrk-success-wrapper').css('display', 'none');
                $('.mrk-error-wrapper').css('display', 'block').find('.mrk-error').text(window.service_not_available);
                $('.mrk-form-input-inner-wrapper').addClass('error');
                $('.choose-services').prop('disabled', true);
            }
        }
    });
    setTimeout(function(){$('.mrk-form-wrapper .mrk-postal-code-input').trigger('input');},100);
    
    // Show the services popup on clicking .mrk-close-btn
    $('.mrk-close-btn').on('click', function() {
        $('.mrk-services-popup').hide();
    });
    // hide the services popup on clicking .choose-services
    $('.choose-services').on('click', function() {
        if($('.mrk-services-popup').length == 0){
            var url = $(this).attr('href');
            location.href = url;
        }
        $('.mrk-services-popup').show();
    });

    // Toggle dropdown options on click and selection
    $('.mrk-services-dropdown-btn').on('click', function() {
        $('.mrk-services-dropdown-wrapper').toggleClass('mrk-options-active');
    });

    // Handle selection of a service
    $('[name="service"]').on('change', function() {
        // Remove active class from all .mrk-drop-down-item
        $('.mrk-drop-down-item').removeClass('mrk-option-active');

        // Add active class to the selected item
        $(this).closest('.mrk-drop-down-item').addClass('mrk-option-active');

        // Update the displayed selected service
        var selectedService = $(this).siblings('label').find('.mrk-dropdown-title').text();
        $('.mrk-service-selected').text(selectedService);

        // Close the dropdown after selection
        $('.mrk-services-dropdown-wrapper').removeClass('mrk-options-active');
        $('.mrk-services-btn-submit').prop('disabled', false);
    });
    $('.mrk-services-btn-submit').on('click', function() {
        var url = $('[name="service"]:checked').attr('url');
        $(this).text('Loading...').prop('disabled', true);
        location.href = url;
    });
    $('.mrk-go-to-previous-page').on('click', function() {
        window.history.back();
    });
    // Close the dropdown if clicked outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.mrk-services-dropdown-wrapper').length) {
            $('.mrk-services-dropdown-wrapper').removeClass('mrk-options-active');
        }
    });

    // services page js 
    $('.qty-btn').on('click', function() {
        var isIncrement = $(this).hasClass('mrk-service-page-increment-btn');
        var quantityDiv = $(this).parents('.mrk-qty-wrapper').find('.mrk-service-page-quantity');
        var hiddenInput = $(this).parents('.mrk-qty-wrapper').find('input.mrk-addon-item');
        
        var currentQuantity = parseInt(quantityDiv.text());
        var newQuantity = isIncrement ? currentQuantity + 1 : Math.max(currentQuantity - 1, 0);
        
        quantityDiv.text(newQuantity);
        hiddenInput.val(newQuantity).trigger('change');
        
        // Update buttons' active status
        var decrementBtn = $(this).parents('.mrk-qty-wrapper').find('.mrk-service-page-decrement-btn');
        console.log(newQuantity);
        if (newQuantity > 0) {
            decrementBtn.addClass('add-remove-btn-active');
        } else {
            decrementBtn.removeClass('add-remove-btn-active');
        }
    });
    $('.mrk-service-page-summary-header').on('click', function() {
        $('.mrk-service-page-summary-container').toggleClass('mrk-drawer-active');
    });
    $('.update-summary').on('input change', updateSummary);
    // Click event for .mrk-service-page-submit-btn
    $('.mrk-service-page-submit-btn').on('click', function() {
        var inputVal = parseFloat($('#area-sqm').val());
        var validInput = !isNaN(inputVal) && inputVal > 0;
        var hasAddon = false;
        var minLimitCondition = true;
        var errorMessage = "";
    
        // Check if the area input exists and is valid
        if ($('#area-sqm').length === 0) {
            validInput = true; // Skip area check if input is not present
            $('.mrk-service-page-window-cleaning-services .mrk-addon-item').each(function() {
                if (parseFloat($(this).val()) > 0) {
                    hasAddon = true;
                    return false; // Exit loop early if at least one addon has value > 0
                }
            });
    
            if (!hasAddon) {
                errorMessage = "Please select at least one service.";
            }
        }
    
        // Display the appropriate error message or proceed with the next step
        if (!validInput) {
            alert("Please enter a valid area in square meters.");
        } else if (errorMessage) {
            alert(errorMessage);
        } else if (validInput && (hasAddon || $('#area-sqm').length > 0)) {
            $('.mrk-services-info').hide();
            $('.mrk-back-btn').attr('back-step', '.mrk-services-info').attr('current-step', '.mrk-date-selector').removeClass('disabled');
            $('.mrk-date-selector').fadeIn();
            $('html, body').animate({
                scrollTop: $('.mrk-date-selector').offset().top - 150
            }, 300);
        }
    });
    

    // Click event for .mrk-date-page-submit-btn
    $('.mrk-date-page-submit-btn').on('click', function() {
        if ($('.mrk-date-input').val() !== '') {
            $('.mrk-date-selector').hide();
            $('.mrk-back-btn').attr('back-step', '.mrk-date-selector').attr('current-step', '.mrk-contact-form').removeClass('disabled');
            $('.mrk-contact-form').fadeIn();
            $('html, body').animate({
                scrollTop: $('.mrk-contact-form').offset().top - 150
            }, 300);
        }else{
            var errorMessage = "Please select Date first!.";
            alert(errorMessage);
        }
    });

    $(document).on('click', '.mrk-back-btn:not(.disabled)', function() {
        var $this = $(this);
        var currentStep = $this.attr('current-step');
        var firstStep = $this.attr('first-step');
        var previousStep = $this.attr('back-step') || firstStep; // Fallback to first step if back-step is not defined
        $this.removeAttr('back-step');
        // Hide the current step and fade in the previous step
        $(currentStep).hide();
        $(previousStep).fadeIn();
        $this.attr('current-step',previousStep);
        // Update the back button state
        if (previousStep === firstStep) {
            $this.addClass('disabled');
        } else {
            $this.removeClass('disabled');
        }
    });
    $('.mrk-service-page-discount-header').click(function() {
        $(this).toggleClass('mrk-discount-active');
        $('.mrk-service-page-discount-form-wrapper').slideToggle('fast');
    });
    $('.mrk-service-page-discount-btn').click(function(event) {
        event.preventDefault();
        var discountCode = $('.mrk-service-page-discount-input').val();
        $('.mrk-discount-input').val(discountCode);
        $('.mrk-discount-success-message').show();
    });
    $('.mrk-close-popup').click(function(){
        $(this).parents('.mrk-popup').hide();
    });
    $('.mrk-service-page-terms-and-conditions a').click(function(e){
        e.preventDefault();
        $('.mrk-terms-and-service-popup').css('display', 'flex');
    });
    $('.mrk-access-option').change(function(){
        if($('.mrk-access-option:checked').hasClass('mrk-other-access')){
           $('.mrk-custom-access').show();
        }else{
            $('.mrk-custom-access').hide(); 
        }
    });
    if(window.mrk_min_limit){
        updateSummary()
    }
    // date picker 
    initDatePicker();
    $('#mrk-lead-form').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        $.ajax({
            url: 'https://script.google.com/macros/s/AKfycbyNLugJXJUDAw09NJ3wRsbUiRyAWLVKM2nvKG32Y2eO8IN73-sWeS6bOF8AHmTzMyIY/exec',
            type: 'POST',
            data: formData,
            success: function(response) {
                // $('form')[0].submit(); 
            },
            error: function() {
                alert('There was an error submitting the data. Please try again.');
            }
        });
    });
});
function initDatePicker() {
    var disableSpecificDates = ["2024-07-25"];

    function disableSpecificDays(date) {
        var day = date.getDay();
        var formattedDate = $.datepicker.formatDate('yy-mm-dd', date);

        // Disable Saturdays (day 6) and Sundays (day 0)
        if (day === 0 || day === 6) {
            // return [false];
        }

        // Disable specific dates
        if (disableSpecificDates.indexOf(formattedDate) !== -1) {
            return [false];
        }

        // Enable all other dates
        return [true];
    }
    $('#datepicker').datepicker({
        minDate: 0, // Disable past dates
        beforeShowDay: disableSpecificDays,
        dayNames: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
        dayNamesMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
        monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
        dateFormat: 'DD d MM',
        defaultDate: null, // No default date selected
        onSelect: function(dateText) {
            $('.mrk-service-page-summary-time').html(dateText);
            $('.mrk-date-input').val(dateText);
        }
    });
}
function updateSummary() {
    var area = parseFloat($('#area-sqm').val()) || 0;
    $('.mrk-area-final').val(`${area} (sqm)`);
    if(area > 0){
        // Find the price object that matches the area
        var priceObj = pricesList.find(function(item) {
            return area >= item.min && area <= item.max;
        });

        // Calculate the main price based on fixedPrice or area-based price (always per week)
        var mainPrice = priceObj.fixedPrice !== 0 ? priceObj.fixedPrice : (priceObj.price * area);
        var priceHtml = '';
        var frequency = $('.mrk-frequency-of-service:checked').val();
        if(frequency){
            mainPrice = priceObj[frequency];
        }
        if(mainPrice > 0){
            // Build the HTML summary for the main price
            var priceHtml = `<div>${Shopify.formatMoney(mainPrice)}</div>`;
        }
        // Assuming you want to display the HTML somewhere on the page
        $('.mrk-major-price').html(priceHtml);
        $('.mrk-major-container').show();
    }else{
        var mainPrice = 0;
        $('.mrk-major-container').hide();
    }
    // Process addons
    var addonSummaryHtml = '';
    var totalPrice = mainPrice;
    var all_services = [];
    $('.mrk-addon-item').each(function() {
        var qty = parseFloat($(this).find('.mrk-addon-item').val());
        var price = parseFloat($(this).find('.mrk-addon-item').attr('price')) || 0;
        var title = $(this).find('.mrk-service-page-service-label').text();
        var extra = parseFloat($(this).find('.mrk-addon-item').attr('extra')) || 0;
        if($('.mrk-service-page-checkbox:checked').val() == 'Yes')
            price = price + extra;
        var itemPrice = price * qty;

        if (itemPrice > 0) {
            addonSummaryHtml += '<div class="mrk-service-page-booking-item">' +
                '<span class="mrk-service-page-booking-item-name">' + title + '</span>' +
                '<span class="mrk-service-page-booking-item-price">' + Shopify.formatMoney(itemPrice) + '</span>' +
            '</div>';
            totalPrice += itemPrice;
        }
    });
    if($('.mrk-windows-list').length){
        $('.mrk-service-page-window-cleaning-services .mrk-addon-item').each(function() {
            if(Number($(this).find('.mrk-addon-item').val()) > 0){
                var title = $(this).find('.mrk-service-page-service-label').text();
                all_services.push(title);
            }
        });
        
        // Join the array into a single string with commas, without a trailing comma
        $('.mrk-windows-list').val(all_services.join(', '));
    }
    if($('.mrk-service-page-additional-services').length){
        var addons = [];
        $('.mrk-service-page-additional-services .mrk-addon-item').each(function() {
            var title = $(this).find('.mrk-service-page-service-label').text();
            addons.push(title);
        });
        
        // Join the array into a single string with commas, without a trailing comma
        $('.mrk-addons-list').val(addons.join(', '));
    }
    $('.mrk-pets-input').val('');
    var all_pets = [];
    $('.mrk-pet-item:checked').each(function(){
        var title = $(this).val();
        all_pets.push(title);
    });
    if($('.mrk-other-pet').is(':checked')){
        $('.mrk-custom-pet').show();
    }else{
        $('.mrk-custom-pet').hide();
    }
    if($('.mrk-other-pet').is(':checked') && $('.mrk-custom-pet').val() != ''){
        var title = $('.mrk-custom-pet').val();
        all_pets.push(title);
    }
    $('.mrk-pets-input').val(all_pets.join(', '));
    // Update the HTML with the addon summary
    $('.mrk-addons-pricing').html(addonSummaryHtml);

    // Show or hide .mrk-service-page-booking-items based on whether totalPrice is 0 or not
    if (totalPrice > 0) {
        $('.mrk-service-page-booking-items').show();
    } else {
        $('.mrk-service-page-booking-items').hide();
    }
    if(window.mrk_min_limit != undefined && window.mrk_min_limit > totalPrice){
        var title = $('.mrk-service-page-title').text();
        var window_cleaning = '<div class="mrk-service-page-booking-item">' +
                '<span class="mrk-service-page-booking-item-name">' + title + '</span>' +
                '<span class="mrk-service-page-booking-item-price">' + Shopify.formatMoney(window.mrk_min_limit) + '</span>' +
            '</div>';
        $('.mrk-addons-pricing').html(window_cleaning).show();
        totalPrice = window.mrk_min_limit;
    }
    window.mrkTotal = totalPrice;
    // Update the final price
    var final_html = Shopify.formatMoney(totalPrice);
    if(frequency){
        $('.mrk-frequency-container').css('display', 'flex');
        $('.mrk-frequency').html($('.mrk-frequency-of-service:checked').attr('title'));
        $('.mrk-frequency-input').val($('.mrk-frequency-of-service:checked').attr('title'));
        final_html = `${Shopify.formatMoney(totalPrice)}/month`;
    }else{
        $('.mrk-frequency-container').hide();
    }
    $('.mrk-final-price-input').val(final_html);
    $('.mrk-final-price').text(totalPrice > 0 ?  final_html : '-');
}